// https://github.com/davidmz/apng-js/blob/40f1104eb911eb057ad5a98b5cfced367049c9b8/src/library/parser.js#L8
const readString = (bytes, off, length) => {
  const chars = Array.prototype.slice.call(bytes.subarray(off, off + length));
  return String.fromCharCode.apply(String, chars);
};

const eachChunk = (bytes, callback) => {
  const dv = new DataView(bytes.buffer);
  let off = 8;
  let type, length, res;
  do {
    length = dv.getUint32(off);
    type = readString(bytes, off + 4, 4);
    res = callback(type, bytes, off, length);
    off += 12 + length;
  } while (res !== false && type != "IEND" && off < bytes.length);
};

const checkBase64IsApng = base64 => {
  const binaryString = atob(base64.split(",")[1]);
  const length = binaryString.length;
  const bytes = new Uint8Array(length);
  for (var i = 0; i < length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  let isApng = false;
  eachChunk(bytes, type => {
    isApng = type === "acTL";
    return !isApng;
  });

  return isApng;
};

export const getBase64Extension = image => {
  if (!image) {
    return "";
  }

  const dataType = image.split(";")[0];
  const extension = dataType && dataType.includes("data:") ? dataType.split("data:")[1] : "";

  if (extension === "image/png") {
    // Check if is apng
    return checkBase64IsApng(image) ? "image/apng" : "image/png";
  }

  return extension;
};

export const getFormat = image => {
  const extension = getBase64Extension(image);
  return extension.includes("/") ? extension.split("/")[1] : "";
};
